module.exports = __webpack_public_path__ + "img/img1.5e25c2b1.png";